export default {
	a_great_community_awaits_you: 'A great community awaits you',
	about_the: 'About the',
	access_platform: 'Access platform',
	access: 'Access',
	active_users: '{users} active users',
	an_email_has_been_sent_to: 'An email has been sent to',
	are_you_a_continental_partner: 'Are you a Continental partner?',
	certificates_obtained_in_training: 'Certificates obtained in training',
	change_country: "Change country",
	check_your_email_for_password_recovery_instructions:
		'Check your email for password recovery instructions.',
	click_on_the_button_below_to_perform_the_first_access:
		'Click on the button below to perform the first access',
	code: 'Code',
	to_the_document_informed: 'to the document informed.',
	ddd_plus_number_ex: 'DDD plus number. Ex. 1199999999',
	discover_new_techniques_in_current_and_diversified_courses:
		'Discover new techniques in current and diversified courses',
	do_apply: 'Do apply',
	document_cpf: 'CPF',
	document: 'Document',
	email_already_in_use_click: 'Email already in use. Click',
	enter_full_company_name: 'Enter the full company name',
	email_invalid_error: 'Invalid email address' ,
	enter_a_new_password: 'Enter a new password.',
	enter_the_code_received_through_the_selected_recovery_method_to_create_a_new_password:
		'Enter the code received through the selected recovery method to create a new password',
		enter_your_document_to_check_the_options_available_with_your_phone_number_for_password_recovery:
		'Enter your document to check the options available with your phone number for password recovery.',
	enter_your_new_password: 'Enter your new password',
	enter_your_phone_number_below_and_press_send_to_receive_a_confirmation_code:
		'Enter your phone number below and press send to receive a confirmation code.',
	error_logging_in_check_the_user_and_password_entered:
		'Error logging in. Check the user and password entered.',
	error_setting_new_password: 'Error setting new password.',
	forgot_password: 'Forgot password',
	select_an_available_option_to_receive_the_verification_code: 'Select an available option to receive the verification code',
	in: 'in',
	log_in_to_receive_an_email_with_instructions_and_a_link_to_create_a_new_password:
		'Type your login document to receive an email with instructions and a link to create a new password.',
	login_to_access_your_account: 'Login to access your account',
	more_than_courses: 'More than {courses} courses',
	no_company_agency_found: 'No company/agency found',
	or: 'Or',
	password_changed_successfully: 'Password changed successfully.',
	password_setting_link_expired:
		'Password setting link expired. Click here on “I forgot my password” to request a new link.',
	phone_number: 'Phone number',
	Please_wait_we_are_validating_your_access: 'Please wait. We are validating your access.',
	recover_password_with_sms: 'Recover password with SMS or Whatsapp',
	recover_password_with_username: 'Recover password with username',
	recover_password: 'Recover password',
	recover_your_password: 'Recover your password',
	request_code: 'Request code',
	request_new_code: 'Request new code',
	sap_code: 'SAP Code',
	seconds: 'seconds',
	select_your_country: 'Select your country',
	select: 'Select',
	send_code: 'Send code',
	set_new_password: 'Set new password',
	sign_in: 'Sign in',
	sign_up: 'Register',
	temporary_password: 'Temporary password',
	terms_of_service: 'Service Terms',
	the_code_sent_is_not_valid: 'The code sent is not valid',
	the_informed_user_could_not_be_found_please_check_the_data_provided:
		'The informed user could not be found. Please check the data provided.',
	the_number_entered_does_not_correspond_to_the_registered_number:
		'The number entered does not correspond to the registered number',
	the_password_reset_link_is_invalid:
		'The password reset link is invalid. Please request a new one.',
	there_is_no_registered_phone_for_this_user: 'There is no registered phone for this user',
	this_site_is_protected_by_googles_recaptcha: 'This site is protected by Google’s recaptcha',
	to_access_this_website_you_need_to_login_first_at_the_intel_retail_edge_program_and_click_on_the_intel_rewards_you_link_on_the_menu:
		'To access this website you need to login first at the Intel® Retail Edge Program and click on the Intel Rewards You link on the menu.',
	to_recover_your_password: 'to recover your password',
	under_maintenance: 'Under maintenance',
	use_document_and_default_password_to_login:
		'Type your login document to receive an email with instructions and a link to create a new password.',
	use_only_numbers_ex: 'Use only numbers. Ex. 123456789',
	use_your_email_or_document_to_recover_your_password:
		'Use your email or document to recover your password',
	user_doesnt_have_access: 'User doesn’t have access',
	user_registered_success: 'User successfully registered.',
	we_are_under_renovation_and_soon_we_will_bring_a_new_platform_full_of_news_for_you:
		'We are under renovation and soon we will have a new platform full of news for you!',
	we_found_the_phone_number: 'We found the phone number',
	welcome_to: 'Welcome to',
	to_recover_your_password_using_email_or_sms:
		'to recover your password using your e-mail or registered phone number. ',
	you_can_recover_your_password_using_your_email_or_document_or_sms:
		"Click on 'Forgot password' and choose to recover it using your e-mail (use your document or e-mail) or SMS (use your phone number) and get a link to create a new password. ",
	you_can_recover_your_password_using_your_email_or_sms:
		"Click on 'Forgot password' and choose to recover it using your e-mail or SMS and get a link to create a new password. ",
	password_recovery: 'Password recovery',
	login_azure: 'Direct Access',
	user_not_found_contact_to: 'User not found. Contact',
	to_request_to_access_on_the_platform: 'to request access to the platform.'
}
